<template>
    <v-container fluid pa-0 ml-2>
        <div v-if="uxCurrentElement == MENU">
                <br>Data<br>
                <a @click="uiEvent('display_all_tables')"> Display all Tables [CoList.vue]</a><br>
                <a @click="uiEvent('display_all_users')"> List of Users [CoReportUser.vue]</a>
                <br><br>Tools<br>
                <a @click="uiEvent('tests_to_moodle')"> Export Tests to Moodle</a><br>
                <a @click="uiEvent('odata_demo')"> Odata Demo [CoOdataDemo.vue]</a><br>
                <a @click="uiEvent('test_mail')"> Send Test Mail [../../myFirebase/firebaseFirestore.js]</a><br>
                <br><br>Experiments<br>
                <a @click="uiEvent('test_component')"> Testcomponent</a><br>
        </div>
                <a @click="uiEvent('leave')" v-if="uxCurrentElement != MENU"> Return to Admin Menue</a><br>
                       
                <CoList v-if="uxCurrentElement == LIST_CoAccessListOverview"></CoList>                                
                <CoReportUser v-if="uxCurrentElement == LIST_CoReportUser"> </CoReportUser>
                <CoReportSapAccounts v-if="uxCurrentElement == LIST_CoReportSapAccounts"> </CoReportSapAccounts>
                <CoReportAccessList v-if="uxCurrentElement == LIST_CoReportAccessList"
                                    v-bind:list_name=list_name>
                </CoReportAccessList>
                <TestComponent v-if="uxCurrentElement == LIST_TestComponent"></TestComponent>               
                <CoOdataDemo  v-if="uxCurrentElement == LIST_CoOdataDemo"></CoOdataDemo>
              
              <div v-if="uxCurrentElement == LIST_Tests">
                <h2>Tests</h2>
                <div v-for="test in tests" :key="test.id">          
                <a @click="ui_event_download_test(test)" :download="createFilename(test)" :href="downloadfile">Download (code in [./../quiz/Moodle]): {{test.long_name}}</a>
                  </div>
                </div>
   
    </v-container>
</template>

<script>
import CoReportUser from "./CoReportUser";
import CoReportAccessList from "./CoReportAccessList";
import CoList from "./CoList";
import CoOdataDemo from "./CoOdataDemo";
import TestComponent from "./TestComponent";

import { the_test_directory } from "../quiz/Tests/the_test_directory";
import { create_moodle_xml } from "./../quiz/Moodle";
const firebaseFirestore = require("../../myFirebase/firebaseFirestore.js");

export default {
  components: {
    CoReportUser,
    CoReportAccessList,
    CoList,
    CoOdataDemo,
    TestComponent,
  },

  data() {
    return {
      // Steuern, welche Componente benutzt wird
      MENU : 0,
      LIST_CoReportAccessList: 1,
      LIST_CoReportUser: 2,
      LIST_CoReportSapAccounts: 3,
      LIST_CoAccessListOverview: 4,
      LIST_TestComponent: 5,
      LIST_Tests: 6,
      LIST_CoOdataDemo: 7,
      LIST_CoAIDemo:8,

      uxCurrentElement: 0, // Display no list (default setting)
      uxShowSelection: true, // true = Alle Menueeinträge anzeigen

      tests: the_test_directory,
      downloadfile: "",

      items: [
         

        {text: "Users - List"},
        {text: "Tables - All"},
        {text: "OData Demo"},
        {text: "Tools -Tests for Moodle"},
        { text: "Tools - Test E-Mail" },
        {text: "OData Demo"},
        {text: "-Legacy, Demo"},
        { text: "SAP WS20/21 (S4)" },      
      ],

      baseUrl: process.env.BASE_URL,
    };
  },

  methods: {
    ui_event_download_test( test ) {
      var s = "data:text/plain;charset=UTF-8,";  
      create_moodle_xml(test, "G24-Demo Moodle").forEach((zeile) => {
        s += zeile;
      });
      this.downloadfile = s;
    },

    createFilename(test){
      return test + ".xml"
    },

    async uiEvent(event) {
      console.log("uiEvent : " + event);
      
  

      let res;
      // Process events, that do not need store call
      switch (event) {
        case "cancel": // return to landing page
          this.$router.push({ name: "Landing" });
          return;

        case "display_all_tables":
          console.log("called ..");
          this.uxCurrentElement = this.LIST_CoAccessListOverview;
          return;


        case "display_all_users":
          this.uxCurrentElement = this.LIST_CoReportUser;
          return;

       case "tests_to_moodle":
          console.log("called ....");
          this.uxCurrentElement = this.LIST_Tests;
          this.tests = the_test_directory;
          console.log(this.tests)
          return;

        case "odata_demo":
          this.uxCurrentElement = this.LIST_CoOdataDemo;
          return;


        case "test_mail":
          res = await firebaseFirestore.write_mail(
            "greipl24@dietergreipl.de",
            "Testnachricht von G24",
            "Diese Nachricht wurde zu Testzwecken  mit der Adminfunktion on G24 gesendet."
          );
          this.$store.commit(
            "setSnackbarText",
            "Testmessage was sent to greipl24@dietergreipl.de"
          );
          return;

        
        case "test_component":
          console.log("called ..");
          this.uxCurrentElement = this.LIST_TestComponent;
          return;

        case "leave":
          this.uxCurrentElement = this.MENU;
          return;

          default:
            console.log("Unknown Event : ", event)
      }
    },
  },

  mounted() {
    console.log("Mounted Component : Admin.vue");
  },
};
</script>
